function Statistika({ telefoni }) {
  return (
    <div className="feedback-stats">
      <h4>{telefoni.length} Telefona</h4>
    </div>
  );
}

export default Statistika;
